// Root-Handle-Klassifizierung: ein Sprecher-Link ist `studio-<slug>`, alles andere ein Gäste-Token.
// React Router kann keinen Prefix-Param im selben Segment, daher fängt /:handle alles und das hier entscheidet.
export type HandleRole = { kind: 'speaker'; slug: string } | { kind: 'guest'; token: string };

const STUDIO_PREFIX = 'studio-';

export function classifyHandle(handle: string): HandleRole {
  if (handle.startsWith(STUDIO_PREFIX) && handle.length > STUDIO_PREFIX.length) {
    return { kind: 'speaker', slug: handle.slice(STUDIO_PREFIX.length) };
  }
  return { kind: 'guest', token: handle };
}
